import { FIELD_TYPES } from "constants/template-field-type";
import ReviewsFieldsConfig from "segments/desktop/core-components/reviews/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Regular",
    fields: ReviewsFieldsConfig
};
